import { type MovieStatus, type TvStatus } from '@tmdb-graphql-api/schema/types';
import { ScreenFormatType } from '#enums/mediaTypes.ts';
import { MovieRibbon } from './Movie/index.tsx';
import { SeasonRibbon } from './Season/index.tsx';
import { TvRibbon } from './Tv/index.tsx';
import { statusHasMovieRibbon, statusHasTvRibbon } from './helpers/statusHasRibbon.ts';
import { type Props } from './types.ts';

const isMovieStatus = (type: ScreenFormatType, _status: MovieStatus | TvStatus): _status is MovieStatus =>
  type === ScreenFormatType.Movie;

export const Ribbon = ({ status, type, ...rest }: Props) => {
  switch (true) {
    case status && isMovieStatus(type, status) && statusHasMovieRibbon(status): {
      return <MovieRibbon status={status} {...rest} />;
    }

    case status && !isMovieStatus(type, status) && statusHasTvRibbon(status): {
      return <TvRibbon status={status} {...rest} />;
    }

    case type === ScreenFormatType.Season: {
      return <SeasonRibbon {...rest} />;
    }

    default: {
      return;
    }
  }
};
